module.exports = require("is");


//////////////////
// WEBPACK FOOTER
// external "is"
// module id = 3
// module chunks = 0